import React from 'react'
import { connect } from 'react-redux'
import GreyBig from './../GreyBig'

class Split extends React.Component {
  render() {
    const {
      loanDetail: {
        summary: {
          fixedAmountLabel,
          variableAmountLabel,
          offsetAccountLabel,
          fixedRepaymentTypeLabel,
          fixedInterestPeriodLabel,
          overallLoanTermLabel,
          variableRepaymentTypeLabel,
        },
        calculator,
      },
    } = this.props

    return(
      <div className='card-body'>
        <GreyBig size='4' big='Split 1 - Fixed' />
        <GreyBig size='4' grey='Loan amount' big={fixedAmountLabel}/>
        <GreyBig size='4' grey='Repayment of' big={calculator.fixed.displayableRepaymentLabelWithFrequency}/>
        <GreyBig size='4' grey='Rate' big={`Fixed rate of ${calculator['fixed'].displayableRateLabel} p.a.`}/>
        <GreyBig size='4' grey='Repayment type' big={fixedRepaymentTypeLabel}/>
        <GreyBig size='4' grey='Fixed loan term' big={fixedInterestPeriodLabel}/>
        <GreyBig size='4' grey='Overall loan term' big={overallLoanTermLabel}/>
        <hr/>
        <GreyBig size='4' big='Split 2 - Variable' />
        <GreyBig size='4' grey='Loan amount' big={variableAmountLabel}/>
        <GreyBig size='4' grey='Repayment of' big={calculator.variable.displayableRepaymentLabelWithFrequency}/>
        <GreyBig size='4' grey='Rate' big={`Variable rate of ${calculator['variable'].displayableRateLabel} p.a.`}/>
        <GreyBig size='4' grey='Repayment type' big={variableRepaymentTypeLabel}/>
        <GreyBig size='4' grey='Overall loan term' big={overallLoanTermLabel}/>
        <GreyBig size='4' grey='Offset account' big={offsetAccountLabel}/>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  loanDetail: state.review.loanDetail,
})

export default connect(mapStateToProps, {
})(Split)
